import script from "./SupportWidget.vue?vue&type=script&setup=true&lang=js"
export * from "./SupportWidget.vue?vue&type=script&setup=true&lang=js"

import "./SupportWidget.vue?vue&type=style&index=0&id=5a0df0b3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5a0df0b3"]])

export default __exports__